/**
 * 班级api
 * 班级api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyBaseVo from './CompanyBaseVo';
import IdNameVo from './IdNameVo';




  /**
   * The MajorCompanyVo model module.
   * @module basic/model/MajorCompanyVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>MajorCompanyVo</code>.
   * @alias module:basic/model/MajorCompanyVo
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>MajorCompanyVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:basic/model/MajorCompanyVo} obj Optional instance to populate.
   * @return {module:basic/model/MajorCompanyVo} The populated <code>MajorCompanyVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'company')) {
        obj['company'] = CompanyBaseVo.constructFromObject(data['company']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dept')) {
        obj['dept'] = IdNameVo.constructFromObject(data['dept']);
      }
    }
    return obj;
  }

  /**
   * 中间表id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 分院
   * @member {module:basic/model/CompanyBaseVo} company
   */
  exports.prototype['company'] = undefined;
  /**
   * 分院
   * @member {module:basic/model/IdNameVo} dept
   */
  exports.prototype['dept'] = undefined;



  export default exports;
;


